import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavLink({ to, label }) {
    const location = useLocation();
    const isActive = location.pathname === to;
    return (
        <li>
            <Link
                to={to}
                className={`nav-link ${isActive ? 'nav-link--active' : ''}`}
            >
                {label}
            </Link>
        </li>
    );
}

export default function NavBar({ user, logout, userDoc }) {
    return (
        <nav className="navbar">
            <div className="navbar__brand">
                <span style={{ fontSize: '1.7rem', verticalAlign: 'middle' }}>📊</span> GLACC
            </div>
            <ul className="navbar__links">
                <NavLink to="/" label="Classifier" />
                <NavLink to="/hours" label="Hours" />
                {userDoc && userDoc.admin && <NavLink to="/upload" label="Upload Data" />}
                {userDoc && userDoc.admin && <NavLink to="/database" label="Database" />}
                {userDoc && userDoc.admin && <NavLink to="/admin" label="Admin" />}
            </ul>
            {user && (
                <button className="btn btn-secondary" style={{ marginLeft: '1.5rem', fontWeight: 600, borderRadius: '8px', padding: '0.5rem 1.2rem' }} onClick={logout}>
                    Logout
                </button>
            )}
        </nav>
    );
}
